export enum RoutesPath {
  PAGE_1 = '',
  PAGE_2 = 'informations-deces-obseques',
  PAGE_3 = 'informations-registrant',
  PAGE_4 = 'informations-notaire',
  PAGE_5 = 'informations-ayant-droit',
  PAGE_6 = 'recapitulatif',
  PAGE_7 = 'confirmation',
  PAGE_ERROR = 'erreur',
}
